module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "yellow-obee"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "sidebar-wrapper"
  }, [(_vm.open) ? _c('navbar-right', {
    attrs: {
      "mobile": true
    }
  }) : _vm._e(), (!_vm.isSideBarChild) ? _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "item-arrow",
    class: [(_vm.isOpenMenu('profile') ? 'open-menu' : ''), (['Account', 'relation', 'Profile', 'relation-add'].includes(this.$route.name) ? 'open-menu' : '')],
    on: {
      "click": function($event) {
        return _vm.openMenu('profile')
      }
    }
  }, [_c('itemArrow', {
    attrs: {
      "title": _vm.user ? _vm.user.fullname : 'Thông tin cá nhân',
      "isActive": _vm.isOpenMenu('profile') || ['Account', 'relation', 'Profile', 'relation-add'].includes(this.$route.name),
      "avatar": _vm.user && _vm.user.avatar || require('../../assets/images/faces/ic_AvatarDefault.svg')
    }
  }), _c('ul', {
    staticClass: "vs-dropdown"
  }, [_c('item', {
    attrs: {
      "title": "Trang cá nhân",
      "icon": "person",
      "href": "/account"
    }
  }), _c('item', {
    attrs: {
      "title": "Bạn bè",
      "href": "/relation",
      "avatar": require("../../assets/images/menu/ic_friends_menu.png")
    }
  })], 1)], 1), (_vm.user && _vm.user.type_user !== 1) ? _c('itemHeader', {
    attrs: {
      "title": "Dành cho Giáo viên"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Tổng quan",
      "icon": "fa fa-th-large",
      "href": "/general"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Quản lý thành viên",
      "avatar": require("../../assets/images/menu/ic_puzzle.png"),
      "href": "/member"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('li', {
    staticClass: "item-arrow",
    class: [(_vm.isOpenMenu('lesson') ? 'open-menu' : ''), (['Lesson', 'Videos', 'Category', 'lesson_add', 'lesson_edit', 'video_add', 'video_edit'].includes(this.$route.name) ? 'open-menu' : '')],
    on: {
      "click": function($event) {
        return _vm.openMenu('lesson')
      }
    }
  }, [_c('itemArrow', {
    attrs: {
      "title": 'Lý thuyết môn học',
      "isActive": _vm.isOpenMenu('lesson') || ['Lesson', 'Videos', 'Category', 'lesson_add'].includes(this.$route.name),
      "avatar": require("../../assets/images/menu/Mask Group 48.png")
    }
  }), _c('ul', {
    staticClass: "vs-dropdown"
  }, [(_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Danh mục bài học",
      "avatar": require("../../assets/images/theory/ic_danhmucbaihoc.png"),
      "href": "/category"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Ds lý thuyết",
      "avatar": require("../../assets/images/menu/Mask Group 105.png"),
      "href": "/lessons",
      "menuChilds": ['Lesson']
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Video bài giảng",
      "avatar": require("../../assets/images/theory/ic_video.png"),
      "href": "/videos",
      "menuChilds": ['Videos']
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('li', {
    staticClass: "item-arrow",
    class: [(_vm.isOpenMenu('lstExercise') ? 'open-menu' : ''), (['exercise', 'category-exercise', 'question', 'category-question', 'exercise_add', 'exercise_edit', 'question_add', 'question_edit'].includes(this.$route.name) ? 'open-menu' : '')],
    on: {
      "click": function($event) {
        return _vm.openMenu('lstExercise')
      }
    }
  }, [_c('itemArrow', {
    attrs: {
      "title": 'Ngân hàng bài tập',
      "isActive": _vm.isOpenMenu('lstExercise') || ['exercise', 'category-exercise', 'question', 'category-question'].includes(this.$route.name),
      "avatar": require("../../assets/images/menu/Mask Group 127.png")
    }
  }), _c('ul', {
    staticClass: "vs-dropdown"
  }, [(_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Danh sách bài tập",
      "avatar": require("../../assets/images/menu/ic_dsbaitap.png"),
      "href": "/exercise",
      "menuChilds": ['exercise']
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Danh mục bài tập",
      "avatar": require("../../assets/images/menu/ic_danhmucbaitap.png"),
      "href": "/category-exercise"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Danh sách câu hỏi",
      "avatar": require("../../assets/images/menu/ic_dscauhoi.png"),
      "href": "/question",
      "menuChilds": ['question']
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Danh mục câu hỏi",
      "avatar": require("../../assets/images/menu/ic_danhmuccauhoi.png"),
      "href": "/category-question"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), (_vm.user && _vm.user.type_user !== 1) ? _c('item', {
    attrs: {
      "title": "Quản lý giáo án",
      "avatar": require("../../assets/images/menu/Mask Group 106.png"),
      "href": "/lesson-planning"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user === 1) ? _c('item', {
    attrs: {
      "title": "Bài tập của tôi",
      "avatar": require("../../assets/images/menu/ic_baitapcuatoi.png"),
      "href": "/result"
    }
  }) : _vm._e(), (_vm.user && _vm.user.type_user === 1) ? _c('item', {
    attrs: {
      "title": "Lớp học của tôi",
      "avatar": require("../../assets/images/menu/Mask Group 155.png"),
      "href": "/classes-to-me"
    }
  }) : _vm._e()], 1) : _c('ul', {
    staticClass: "nav"
  }, [(_vm.user && _vm.user.type_user === 1) ? _c('itemLevel', {
    attrs: {
      "title": "Lớp học của tôi",
      "href": "/classes-to-me"
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "sidebar-background"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo logo-mobile"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Obee_Logo_140@2x.png"),
      "height": "65px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d93e81","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/index.vue
// module id = 1562
// module chunks = 0